import _ from 'lodash'
import { JSONEditor } from '@json-editor/json-editor'
import Choices from 'choices.js'

class TagsEditor extends JSONEditor.AbstractEditor {
  preBuild () {
    this.value = []

    if (this.schema.enumSource) {
      this.enumSource = []

      this.enumSource = _.map(this.schema.enumSource, (source) => {
        if (typeof source === 'string') {
          return { source }
        } else if (!Array.isArray(source)) {
          return _.clone(source)
        } else {
          return source
        }
      })

      _.each(this.enumSource, (source) => {
        if (source.value) {
          source.value = this.jsoneditor.compileTemplate((source.value), this.template_engine)
        }
        if (source.title) {
          source.title = this.jsoneditor.compileTemplate((source.title), this.template_engine)
        }
        if (source.filter) {
          source.filter = this.jsoneditor.compileTemplate((source.filter), this.template_engine)
        }
      })
    }
  }

  build () {
    this.container.classList.add('tags')

    this.header = document.createElement('span')
    this.header.textContent = this.getTitle()
    this.title = this.theme.getHeader(this.header)
    this.container.appendChild(this.title)

    this.input = this.theme.getSelectInput()
    this.input.setAttribute('multiple', 'true')
    this.input.addEventListener('change', (e) => {
      this.refreshValue()
    })

    if (this.schema.description) {
      this.description = this.theme.getDescription(this.translateProperty(this.schema.description))
      this.container.appendChild(this.description)
    }

    this.container.appendChild(this.input)

    this.choices = new Choices(this.input, {
      duplicateItemsAllowed: false,
      paste: false,
      editItems: false,
      removeItemButton: true,
      shouldSort: false,
      placeholderValue: 'Select an attribute...',
      noResultsText: 'No matching attributes',
      noChoicesText: 'No attributes available'
    })
  }

  postBuild () {
    super.postBuild()
  }

  setValue (value, initial) {
    this.value = Array.isArray(value) ? value : []
    this.onChange(true)
  }

  refreshValue () {
    this.value = this.choices.getValue(true)
    this.onChange(true)
  }

  onWatchedFieldChange () {
    if (this.enumSource) {
      const vars = this.getWatchedFieldValues()

      const currentValue = this.value
      const compiledSource = _.reduce(this.enumSource, (result, source) => {
        if (Array.isArray(source)) {
          result.push(source)
        } else {
          let items = []
          if (Array.isArray(source.source)) {
            items = source.source
          } else {
            items = vars[source.source]
          }

          const traverse = function (arr, nestedResult, depth, selected) {
            depth = depth || 0
            _.each(arr, (item, i) => {
              let title = source.title ? source.title({ i, item }) : item.title
              const value = source.value ? source.value({ i, item }) : item.value

              if (depth) {
                title = `<span class="nested">${_.repeat('&nbsp;', depth * 4)}&#x21B3;&nbsp;</span>${title}`
              }

              const obj = {
                depth,
                value: value,
                title: title,
                selected: currentValue.indexOf(value) >= 0
              }
              obj.disabled = obj.selected || selected
              result.push(obj)
              if (item.children) {
                traverse(item.children, nestedResult, depth + 1, obj.selected || selected)
              }
            })
            return nestedResult
          }
          result = result.concat(traverse(items, []))
        }
        return result
      }, [])

      const choices = _.filter(compiledSource, 'value')

      this.choices.clearStore()
      this.choices.setChoices(choices, 'value', 'title', true)

      const values = _.map(choices, 'value')
      const cleanValue = _.intersection(currentValue, values)
      if (!_.isEqual(currentValue, cleanValue)) {
        this.value = cleanValue
        if (this.parent) {
          this.parent.onChildEditorChange(this)
        } else {
          this.jsoneditor.onChange()
        }
        this.jsoneditor.notifyWatchers(this.path)
      }
    }

    super.onWatchedFieldChange()
  }
}

export default TagsEditor
